import { render, staticRenderFns } from "./InsuranceDocumentsFaqs.vue?vue&type=template&id=7b810033&scoped=true"
import script from "./InsuranceDocumentsFaqs.vue?vue&type=script&lang=js"
export * from "./InsuranceDocumentsFaqs.vue?vue&type=script&lang=js"
import style0 from "./InsuranceDocumentsFaqs.vue?vue&type=style&index=0&id=7b810033&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b810033",
  null
  
)

export default component.exports